module.exports = __webpack_public_path__ + "img/lithuania.8ef6a3cc.svg";